import set from 'lodash/set';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import config from '@/config';

export default ({ Vue }) => {
  if (config.ApplicationInsightsKey && config.ApplicationInsightsKey.length) {
    const appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: config.ApplicationInsightsKey,
      },
    });
    appInsights.loadAppInsights();

    set(window, 'appInsights', appInsights);
    set(Vue, 'appInsights', appInsights);

    Object.defineProperty(Vue.prototype, '$appInsights', {
      get: () => Vue.appInsights,
    });
  }
};



// WEBPACK FOOTER //
// ./src/plugins/vue-application-insights.js